import { render } from "./Groothuiskamerconcert.vue?vue&type=template&id=a82a4c20&scoped=true"
import script from "./Groothuiskamerconcert.vue?vue&type=script&lang=js"
export * from "./Groothuiskamerconcert.vue?vue&type=script&lang=js"

import "./Groothuiskamerconcert.vue?vue&type=style&index=0&id=a82a4c20&lang=scss&scoped=true"

import exportComponent from "/Users/Sacha/Projects/muziekdichtbij/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82a4c20"]])

export default __exports__